__turbopack_context__.v({
  "loop": "styles-module-scss-module__vMSY-q__loop",
  "swiper": "styles-module-scss-module__vMSY-q__swiper",
});
